import z from 'zod';
function createStrictSchema() {
    // biome-ignore format: better readability
    return (schema) => z.object(schema);
}
export { createStrictSchema };
//# sourceMappingURL=zod-helpers.js.map